import * as Colors from "@material-ui/core/colors";
import { Color } from "@material-ui/core";

type ColorPaletteKey = keyof typeof Colors;
type ColorKey = keyof Color;

const AllColorPalette: Record<ColorPaletteKey, Color> = (Colors as unknown) as Record<ColorPaletteKey, Color>;
const colorPaletteKeys = Object.keys(AllColorPalette) as ColorPaletteKey[];

export const getRandomMaterialColor = (): string => {
  const randomPaletteKey = colorPaletteKeys[(colorPaletteKeys.length * Math.random()) << 0];
  const colorKeys = Object.keys(AllColorPalette[randomPaletteKey]) as ColorKey[];
  const randomColorKey = colorKeys[(colorKeys.length * Math.random()) << 0] as ColorKey;

  return AllColorPalette[randomPaletteKey][randomColorKey];
};

export const stringToHash = (s: string): number => {
  return s.split("").reduce(function (a, b) {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
};

export const getRandomColorBasedOnString = (base: string): string => {
  const hashValue = Math.abs(stringToHash(base));
  const colorPaletteIdx = hashValue % colorPaletteKeys.length;
  const randomPaletteKey = colorPaletteKeys[colorPaletteIdx];
  const colorKeys = Object.keys(AllColorPalette[randomPaletteKey]) as ColorKey[];
  const colorKeyIdx = hashValue % colorKeys.length;
  const randomColorKey = colorKeys[colorKeyIdx];

  return AllColorPalette[randomPaletteKey][randomColorKey];
};
